import { render, staticRenderFns } from "./moderatorTimeInfo.vue?vue&type=template&id=2ca0b33a&"
import script from "./moderatorTimeInfo.vue?vue&type=script&lang=js&"
export * from "./moderatorTimeInfo.vue?vue&type=script&lang=js&"
import style0 from "./moderatorTimeInfo.vue?vue&type=style&index=0&lang=less&csoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports